module.exports = __webpack_public_path__ + "img/icon-mail.b9a9d807.svg";